/* EZ Rides — mega menu events (snippets/ez-mega-menu.liquid)
   Publishes two custom events through Shopify's Customer Events API so a custom
   pixel can forward them to GA4 or Meta. Setup: EZ-MEGA-MENU-SETUP.md.

     ez_nav_open   { category, device }                              once per open
     ez_nav_click  { category, zone, position, label, href, device }

   zone is one of: all, tile, pick, guide, guide-page, help, trust.
   Loaded deferred from sections/header.liquid, only when an EZ mega menu entry
   exists. No dependencies; does nothing if the analytics API is missing. */
(function () {
  'use strict';

  if (window.ezMegaMenuEvents) return;
  window.ezMegaMenuEvents = true;

  var lastOpen = { key: '', time: 0 };

  function publish(name, data) {
    try {
      if (window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === 'function') {
        Shopify.analytics.publish(name, data);
      }
    } catch (error) {
      /* analytics must never break navigation */
    }
  }

  function deviceFor(element) {
    return element.closest('.ez-mm--drawer') ? 'mobile' : 'desktop';
  }

  document.addEventListener('click', function (event) {
    var target = event.target.closest ? event.target.closest('[data-ez-mm-zone]') : null;
    if (!target) return;
    var panel = target.closest('[data-ez-mm]');
    publish('ez_nav_click', {
      category: panel ? panel.getAttribute('data-ez-mm') : '',
      zone: target.getAttribute('data-ez-mm-zone') || '',
      position: parseInt(target.getAttribute('data-ez-mm-pos') || '0', 10),
      label: (target.textContent || '').replace(/\s+/g, ' ').trim().slice(0, 120),
      href: target.getAttribute('href') || '',
      device: deviceFor(target)
    });
  }, true);

  /* "toggle" does not bubble, so listen in the capture phase. */
  document.addEventListener('toggle', function (event) {
    var details = event.target;
    if (!details || details.tagName !== 'DETAILS' || !details.open) return;
    var panel = details.querySelector(':scope > .ez-mm, :scope > .menu-drawer__submenu > .menu-drawer__inner-submenu > .ez-mm');
    if (!panel) return;
    var category = panel.getAttribute('data-ez-mm') || '';
    var device = deviceFor(panel);
    var key = category + '|' + device;
    var now = Date.now();
    /* Hover menus can flicker open and closed; count one open per 2 seconds. */
    if (lastOpen.key === key && now - lastOpen.time < 2000) return;
    lastOpen = { key: key, time: now };
    publish('ez_nav_open', { category: category, device: device });
  }, true);
})();
